export default __webpack_public_path__ + "static/media/product-14 (1).09ea8305.jpg";